import { Substrate } from './types';

export function getLinenSubstrate(): Substrate {
    return {
        color: 0xFFFFFF,
        shininess: 20,
        bumpScale: 6,
        bumpTexture: {
            dpi: 200,
            sourceUrl: 'https://vortex.documents.cimpress.io/substrates/linen/v1/bump',
        },
    };
}
